/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect} from 'react';
import useToggle from "../../hook/ToggleHook";
import {useQuery} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useAuthService} from "../../hook/AuthServiceHook";
import {useRegion} from "../../context/RegionContext";
import {get_primary_email} from "../../service/common";
import axios from "axios";

const HeaderUtilAccountComponent = () => {
    const {t} = useTranslation();
    const {AUTHAPI} = useAuthService();
    const {url} = useRegion();
    const [open, node] = useToggle();
    const {data} = useQuery({
        queryKey: ["get_user_info"],
        queryFn: async () => {
            const res = await AUTHAPI.user_info();
            window.localStorage.setItem('currentUser', JSON.stringify(res.result));
            return res.result;
        }
    });

    const logout = () => {
        window.localStorage.removeItem('currentOrg');
        window.localStorage.removeItem('currentUser');
        sessionStorage.removeItem('access_token');
        AUTHAPI.logout();
    }

    const getCurrentUser = () => {
        const localUser = JSON.parse(window.localStorage.getItem('currentUser'));
        return data || localUser || {};
    }

    const goToAccProfile = () => {
        const query = {
            state: window.location.pathname,
            redirect_uri: `${url.get_org_center_domain()}/oauth/receive_auth`,
            lang: window.localStorage.getItem('userLang'),
            app_id: window._env_.REACT_APP_OAUTH_CLINET_ID
        }
        const searchParams = new URLSearchParams(query);
        return `${url.get_acc_url()}?${searchParams.toString()}`;
    }


    return (
        <div className="util-btn util-account" ref={node}>
            <div className={`avatar ${getCurrentUser()?.avatars ? '' : 'no-avatar'}`}>
                {getCurrentUser()?.avatars && <img src={getCurrentUser()?.avatars.small} alt={''}/>}
                {!getCurrentUser()?.avatars && <span>{getCurrentUser()?.display_name?.[0]}</span>}
            </div>
            <div className={"comp-dropdown " + open}>
                <ul className="comp-dropdown-menu">
                    <li className="section account-section">
                        <div className="section-head">{t('@Account Management@')}</div>
                        <div className="section-items selection current-account" onClick={()=>window.open(`${goToAccProfile()}`, '_blank')}>
                            <div className="account-img">
                                <div className={`avatar ${getCurrentUser()?.avatars ? '' : 'no-avatar'}`}>
                                    {getCurrentUser()?.avatars && <img src={getCurrentUser()?.avatars.small} alt={''}/>}
                                    {!getCurrentUser()?.avatars && <span>{getCurrentUser()?.display_name?.[0]}</span>}
                                </div>
                            </div>
                            <div className="account-info">
                                <div className="name">{getCurrentUser()?.display_name}</div>
                                <div className="mail">{get_primary_email(getCurrentUser())}</div>
                            </div>
                        </div>
                    </li>
                    <li className="section-divide" />
                    <li className="section" onClick={logout}>
                        <div className="section-items selection">{t('@Sign out@')}</div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default HeaderUtilAccountComponent;